import {combineReducers} from '@modifi/redux'
import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'

import collectionReducer from './collections'

export default combineReducers({
  collection: collectionReducer,
})

export type AddressStateState = KeyWindowState<any>
